/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { StringInputProps } from '../../../types/InputComponentProps';
import { Input, Textarea } from 'chakra-v3';
import { InputContainer } from './FormInputContainer';

export function FormInput(props: StringInputProps) {
  const { id, description, long, label, error, isInvalid, isDisabled, isRequired, size: _size, ...rest } = props;
  const value = rest.value;
  const hasValue = value !== undefined && value !== null && value !== '';
  return (
    <InputContainer
      id={id}
      description={description}
      label={label}
      error={error}
      isInvalid={isInvalid}
      isRequired={isRequired}
      isDisabled={isDisabled}
    >
      {long ? (
        <Textarea
          id={id}
          bg="brand.tealDark"
          borderColor="brand.cta"
          color={hasValue ? 'text.primary' : 'text.placeholder'}
          h="48px"
          px="16px"
          py="12px"
          borderRadius="4px"
          fontSize="16px"
          lineHeight="1.4"
          letterSpacing="0.08px"
          fontFamily="body"
          fontWeight="normal"
          _placeholder={{ color: 'text.placeholder' }}
          {...rest}
        />
      ) : (
        <Input
          id={id}
          bg="brand.tealDark"
          borderColor="brand.cta"
          color={hasValue ? 'text.primary' : 'text.placeholder'}
          h="48px"
          px="16px"
          py="12px"
          borderRadius="4px"
          fontSize="16px"
          lineHeight="1.4"
          letterSpacing="0.08px"
          fontFamily="body"
          fontWeight="normal"
          _placeholder={{ color: 'text.placeholder' }}
          {...rest}
        />
      )}
    </InputContainer>
  );
}
